const allinvoicerec = { data: [], loading: true };
const allinvoicerecpopulate = { data: [], loading: true };

export const GetAllInvoiceRec = (state = allinvoicerec, action) => {
  switch (action.type) {
    case "get_allinvoicerec":
      return {
        data: action?.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAllInvoiceRecPopulate = (state = allinvoicerecpopulate, action) => {
  switch (action.type) {
    case "get_addinvoicerecpopulate":
      return {
        data: action?.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
